<template>
  <div class="notice-body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'notice-body'
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";

  .notice-body {
    @include mq-down(md) {
      text-align: left;
    }
    @include mq-up(md) {
      line-height: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/box/NoticeBody.vue